<template>
  <teleport to="#modal_backdrop">
    <div @click="this.$emit('exitModal')" class="backdrop-popup"></div>
    <div class="modal-popup gap-10">
      <h5>עריכת סגירה אוטומטית</h5>
      <div class="flex gap-10 auto-close-toggle">
        <label for="edit-auto-close-checkbox">סגירה אוטומטית</label>
        <input
          id="edit-auto-close-checkbox"
          type="checkbox"
          v-model="autoClose"
        />
      </div>
      <div v-if="autoClose" class="flex gap-10 auto-close-toggle">
        <label>מספר שניות לסגירה</label>
        <input type="number" min="1" v-model.number="autoCloseSeconds" />
      </div>
      <BaseButton @click="save" class="submit">שמירה</BaseButton>
    </div>
  </teleport>
</template>

<script>
import BaseButton from "../helpers/BaseButton.vue";
export default {
  components: {
    BaseButton,
  },
  emits: ["exitModal", "save"],
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      autoClose: this.alert.autoClose || false,
      autoCloseSeconds: this.alert.autoCloseSeconds || 5,
    };
  },
  methods: {
    save() {
      if (this.autoClose && !(this.autoCloseSeconds > 0)) {
        this.autoCloseSeconds = 5;
      }
      this.$emit("save", {
        alert: this.alert.alert,
        autoClose: this.autoClose,
        autoCloseSeconds: this.autoCloseSeconds,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.backdrop-popup {
  background-color: #000000;
  opacity: 0.6;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 11;
}

.modal-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 12;
  border-radius: 40px;
  background: #393945;
  padding: 30px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 330px;
  animation: modalEnter 1s;
  color: white;
}

label {
  font-size: $mediumTextSize;
}

.auto-close-toggle {
  margin: 10px 0;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  input[type="checkbox"] {
    width: 20px;
    opacity: 1;
    position: static;
    pointer-events: fill;
    border-bottom: none;
    box-shadow: none;
  }

  input[type="number"] {
    color: white;
  }
}

.submit {
  width: 100%;
}

@keyframes modalEnter {
  0% {
    opacity: 0;
    transform: translate(-50%, calc(-50% - 200px));
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
</style>
